import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ItemPage"] */ "/app/src/app/(shop)/[slug]/components/itemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MerchantFooter"] */ "/app/src/components/merchantFooter/merchantFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotAcceptingOrdersBannerContent"] */ "/app/src/components/notAcceptingOrdersBanner/notAcceptingOrdersBannerContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pagination/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SortDropDown"] */ "/app/src/components/sortDropdown/sortDropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/mocks/assets/defaultImage.png");
